import { render } from "./ImagensImovel.vue?vue&type=template&id=12b679f9"
import script from "./ImagensImovel.vue?vue&type=script&lang=js"
export * from "./ImagensImovel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__